import Icon from '../components/Icon.vue'

Icon.register({
  stethoscope: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M447.1 112C412.9 112.5 384.8 140.4 384.1 174.6 383.6 198.9 396.6 220.2 416.1 231.4V344C416.1 401.3 365.9 448 304.1 448 244.1 448 194.9 403.9 192.2 348.8 265 333.8 320 269.2 320 192V36.6C320 25.2 311.9 15.3 300.7 13.1L237.8 0.5C224.8-2.1 212.2 6.3 209.6 19.3L206.4 35C203.8 48 212.2 60.6 225.2 63.2L255.9 69.3V190.7C255.9 243.6 213.7 287.4 160.8 287.9 107.4 288.4 63.9 245.2 63.9 191.9V69.4L94.6 63.3C107.6 60.7 116 48.1 113.4 35.1L110.3 19.4C107.7 6.4 95.1-2 82.1 0.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192C0 269.3 55.1 334 128.1 348.8 130.7 439.2 208.6 512 304 512 401 512 480 436.6 480 344V231.4C499.1 220.3 512 199.7 512 176 512 140.3 482.8 111.5 447.1 112zM448 192C439.2 192 432 184.8 432 176S439.2 160 448 160 464 167.2 464 176 456.8 192 448 192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/stethoscope.js
// module id = WR0z
// module chunks = 144